import {HTTP_METHODS} from '@/utils/constants/httpMethods'

export const ACTIVITY_CONFIG = {
  ACTIVITIES: {
    endPoint: 'activities',
    method: HTTP_METHODS.POST,
  },
  UPDATE_ACTIVITY: {
    endPoint: 'activities',
    method: HTTP_METHODS.PUT,
  },
  SAVE_DRAFT_ACTIVITY: {
    endPoint: 'activities/draft',
    method: HTTP_METHODS.POST,
  },
  UPDATE_DRAFT_ACTIVITY: {
    endPoint: 'activities/draft',
    method: HTTP_METHODS.PUT,
  },
  VALIDATE_ACTIVITY_NAME: {
    endPoint: `activities/validate-name`,
    method: HTTP_METHODS.GET,
    appendQueryParams: true,
  },
  GET_ACTIVITY: {
    endPoint: 'activities/list',
    method: HTTP_METHODS.POST,
    appendQueryParams: true,
    // mockData: ActivitiesData
  },
  ACTIVITY_CSV_DOWNLOAD: queryParams => ({
    endPoint: `activities/download${queryParams ? `?${queryParams}` : ''}`,
    method: HTTP_METHODS.POST,
  }),

  ACTIVITY_DURATION_VALIDATION: {
    endPoint: 'activities/validate',
    method: HTTP_METHODS.POST,
  },
  ACTIVITY_HISTORY: {
    endPoint: 'rewards/users/activities',
    method: HTTP_METHODS.GET,
  },
  SEARCH_PHONE_NUMBER: {
    endPoint: 'rewards/users/stores',
    method: HTTP_METHODS.GET,
  },
}
